import styled from 'styled-components'
import Icon from '@mdi/react'

import CommonLinkButton from 'components/Button/CommonLinkButton'
import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const JobNoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.lightGrey};
  padding-bottom: 20px;
`

export const JobNoteHeaderLeftBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  ${Font14};
`

export const JobNoteHeaderRightBlock = styled.div`
  display: flex;
  align-items: center;
`

export const JobNoteButton = styled(CommonLinkButton)`
  padding-left: 14px;
`

export const JobNoteIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const JobNoteGreyIcon = styled(JobNoteIcon)`
  color: ${theme.colors.dolphinGrey};
  margin-right: 12px;
`

export const JobNoteHeaderRightBlockEmail = styled.div`
  color: ${theme.colors.darkeyGrey};
`
export const JobNoteHeaderRightBlockDelimiter = styled.div`
  margin: 0 10px;
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const JobNoteBody = styled.div`
  display: flex;
  width: 100%;
  margin-top: 16px;
  ${Font14};
  line-height: 22px;
`

export const JobNoteModalSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 64px;
`

export const JobNoteModalBlock = styled.div`
  margin: 8px 0;
`
